import { BehaviorSubject } from 'rxjs';

export const shoppingCartRefreshRequested$ = new BehaviorSubject(null);

export function refreshShoppingCart() {
  shoppingCartRefreshRequested$.next(true);
}
